import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-message',
  templateUrl: './modalmessage.component.html',
  styleUrls: ['./modalmessage.component.scss']
})
export class ModalMessageComponent {
  
  @Input() modalTitle: string;
  @Input() modalMessage: string;

  constructor(public activeModal: NgbActiveModal) {}

}
